import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, X } from 'lucide-react';

function ImpersonationBanner() {
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [impersonatedUser, setImpersonatedUser] = useState(null);
  const [impersonationType, setImpersonationType] = useState('provider');
  const navigate = useNavigate();

  useEffect(() => {
    const impersonating = localStorage.getItem('impersonating') === 'true';
    setIsImpersonating(impersonating);

    if (impersonating) {
      const type = localStorage.getItem('impersonating_type') || 'provider';
      setImpersonationType(type);

      if (type === 'couple') {
        const couple = JSON.parse(localStorage.getItem('couple') || '{}');
        setImpersonatedUser(couple);
      } else {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        setImpersonatedUser(user);
      }
    }
  }, []);

  const stopImpersonating = () => {
    const type = localStorage.getItem('impersonating_type') || 'provider';

    // Restore original user data
    const originalUser = localStorage.getItem('impersonate_original_user');
    const originalToken = localStorage.getItem('impersonate_original_token');
    const originalCoupleToken = localStorage.getItem('impersonate_original_couple_token');

    if (originalUser) {
      localStorage.setItem('user', originalUser);
    }
    if (originalToken) {
      localStorage.setItem('token', originalToken);
    }
    if (originalCoupleToken) {
      localStorage.setItem('coupleToken', originalCoupleToken);
    } else {
      localStorage.removeItem('coupleToken');
    }

    // Remove impersonation flags and couple data
    localStorage.removeItem('impersonating');
    localStorage.removeItem('impersonating_type');
    localStorage.removeItem('impersonate_original_user');
    localStorage.removeItem('impersonate_original_token');
    localStorage.removeItem('impersonate_original_couple_token');
    localStorage.removeItem('couple');

    // Navigate to admin panel
    navigate('/admin');
    window.location.reload();
  };

  if (!isImpersonating) {
    return null;
  }

  return (
    <>
      {/* Fixed banner at top */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-orange-500 to-red-500 text-white px-4 py-2 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            <div className="text-sm">
              <span className="font-bold">IMPERSONATING {impersonationType === 'couple' ? 'COUPLE' : 'PROVIDER'}:</span>{' '}
              <span className="font-medium">
                {impersonationType === 'couple'
                  ? (impersonatedUser?.name || impersonatedUser?.email)
                  : (impersonatedUser?.business_name || impersonatedUser?.email)}
              </span>
            </div>
          </div>
          <button
            onClick={stopImpersonating}
            className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-lg transition-colors font-medium text-sm"
          >
            <X className="w-4 h-4" />
            Stop
          </button>
        </div>
      </div>
      {/* Spacer to push content down */}
      <div className="h-10"></div>
    </>
  );
}

export default ImpersonationBanner;
